import { ADD_LCD, REMOVE_LCD, ACTIVE_LCD, LOGIN_LOGOUT_USER, LOADER_DISPLAY_HIDE, SET_LANGUAGE, ACTIVE_DEAL_ADVERTISEMENT } from './actionTypes'

export const activeDealAdvertisement = (content: any) => ({
    type: ACTIVE_DEAL_ADVERTISEMENT,
    payload: {
        content
    }
})

let nextItemId = 0;
export const addLcd = (content: any) => ({
    type: ADD_LCD,
    payload: {
        id: ++nextItemId,
        content
    }
})

export const editLcd = (content: any) => ({
    type: REMOVE_LCD,
    payload: {
        content
    }
})

export const activeLcd = (content: any) => ({
    type: ACTIVE_LCD,
    payload: {
        content
    }
})

export const loginLogoutUserAction = (content: any) => ({
    type: LOGIN_LOGOUT_USER,
    payload: {
        content
    }
})

export const loaderDisplayHideAction = (content: any) => ({
    type: LOADER_DISPLAY_HIDE,
    payload: {
        content
    }
})

export const setLanguageAction = (content: any) => ({
    type: SET_LANGUAGE,
    payload: {
        content
    }
})